import { FC } from 'react'
import { SocialMediaCellType } from './social-media-cell.types'

import { Followers, Engagement } from './value-type.comp'

export const SocialMediaCell: FC<SocialMediaCellType> = ({
  tiktokUrl,
  bottomText,
  tiktokValue,
  instagramUrl,
  instagramValue,
  valueType = 'wholeNumber',
}) => {
  return (
    <div>
      {valueType === 'wholeNumber' ? (
        <Followers
          instagramValue={instagramValue}
          tiktokValue={tiktokValue}
          instagramUrl={instagramUrl}
          tiktokUrl={tiktokUrl}
          bottomText={bottomText}
        />
      ) : (
        <Engagement
          instagramValue={instagramValue}
          tiktokValue={tiktokValue}
          instagramUrl={instagramUrl}
          tiktokUrl={tiktokUrl}
          bottomText={bottomText}
        />
      )}
    </div>
  )
}
